module.exports = __webpack_public_path__ + "img/hora1.1b637afe.jpg";